/**
 * Data layer for `real-time-link-coupon-interaction-monitoring-influ`. Thin typed fetch wrappers over /api/v1/real-time-link-coupon-interaction-monitoring-influ.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface RealTimeLinkCouponInteractionMonitoringInfluRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListRealTimeLinkCouponInteractionMonitoringInfluResponse {
	count: number;
	items: RealTimeLinkCouponInteractionMonitoringInfluRow[];
}

export interface CreateRealTimeLinkCouponInteractionMonitoringInfluBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/real-time-link-coupon-interaction-monitoring-influ";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListRealTimeLinkCouponInteractionMonitoringInfluResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListRealTimeLinkCouponInteractionMonitoringInfluResponse>(res);
}

export async function create(body: CreateRealTimeLinkCouponInteractionMonitoringInfluBody): Promise<RealTimeLinkCouponInteractionMonitoringInfluRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<RealTimeLinkCouponInteractionMonitoringInfluRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const realTimeLinkCouponInteractionMonitoringInfluQueryKeys = {
	all: ["real-time-link-coupon-interaction-monitoring-influ"] as const,
	list: () => [...realTimeLinkCouponInteractionMonitoringInfluQueryKeys.all] as const,
	detail: (id: string) => [...realTimeLinkCouponInteractionMonitoringInfluQueryKeys.all, id] as const,
};
